<template>
  <v-container id="osakana-employee-recruitment">
    <v-card>
      <v-img
        :src="require('@/assets/OsakanaTeruteru/osakana_banner.jpg')"
        height="230"
        width="100%"
        alt="おさかなてるてるの外装写真"
      >
        <v-row class="fill-height ma-0" align="center" justify="center">
          <div class="py-8 px-12">
            <h2
              class="font-weight-light banner-font-style font-weight-bold main-title"
            >
              採用情報
            </h2>
            <div
              class="subtitle-1 banner-font-style font-weight-bold text-decoration-underline"
              align="center"
            >
              RECRUITMENT
            </div>
          </div>
        </v-row>
      </v-img>
    </v-card>

    <v-row justify="center" align-content="center" class="ma-0">
      <v-card flat class="hiring-message" color="transparent">
        <v-card-text class="recruitment-message ">
          てるてる各店舗では<br />
          一緒に働ける仲間を<br class="sp-br" />募集しています！<br />
        </v-card-text>
        <v-card-text align="center" justify="center">
          <v-btn
            to="/job-description"
            class="ma-2 black--text link-detail"
            color="osakanaSubColor"
          >
            詳しくはこちら
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-row>
    <teruteru-logos></teruteru-logos>
  </v-container>
</template>

<script>
import TeruteruLogos from "@/components/Common/TeruteruLogos";
export default {
  name: "EmployeeRecruitment",
  components: { TeruteruLogos }
};
</script>

<style lang="scss" scoped>
.banner-font-style {
  color: black;
  text-shadow: 2px 2px 5px white, -2px 2px 5px white, 2px -2px 5px white,
    -2px -2px 5px white;
}

.main-title {
  font-size: 2em;
  @include display_pc {
    font-size: 3em;
  }
}

.recruitment-message {
  font-size: 1.5em;
  line-height: 1.5em;
  text-align: center;
  @include display_pc {
    font-size: 1.75em;
    line-height: 1.5em;
  }
}

.sp-br {
  @include display_pc {
    display: none;
  }
}
</style>
